import styled from 'styled-components'
import { mediaqueries } from '~/utils/mediaqueries'

import {
  Tab as ReactTab,
  Tabs as ReactTabs,
  TabList as ReactTabList,
} from 'react-tabs'

export const Tabs = styled(ReactTabs)``

export const Tab = styled(ReactTab)`
  text-align: center;
  outline: none;
  cursor: pointer;
  position: relative;

  &:after,
  &:before {
    content: '';
    position: absolute;
  }

  ${({ theme: { toRem, color } }) => `
    padding: ${toRem(20)} 0;

    &:before {
        content: '';
        bottom: 0;
        left: 0;
        right: 0;
        height: ${toRem(4)};
        background: ${color('core')}
        display: block;
        opacity: 0;
    }

    &.react-tabs__tab--selected {
        &:before { opacity: 1;}
    }
  `}
`

export const TabList = styled(ReactTabList)`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  min-width: 660px;
  padding: 0 30px 0 0;

  ${({ theme: { color } }) => `
        border-bottom: 1px solid ${color('accent', 80)};
        background: ${color('light')};
   `}
`

export const TabListWrap = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  max-width: 100vw;
`

export const TabPanel = styled.div`
  ${({ theme: { toRem } }) => `
    padding:  30px ${toRem(20)} ;
    min-height: ${toRem(65)};
  `}

  h4 {
    margin-bottom: -5px;
  }

  @media ${`${mediaqueries.sm} and ${mediaqueries.max.md}`} {
    display: flex;
    flex-wrap: wrap;
  }
`

export const TabListDecorationWrap = styled.div`
  position: relative;

  &:after {
    content: '';
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 40%,
      rgba(255, 255, 255, 0.2) 100%
    );
    right: 0;
    top: 0;
    position: absolute;
    bottom: 0;
    width: 52px;
  }
`
